import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AclPermissionDetail } from '@y42/acl/models';
import { createAclPermissionDetail } from '@y42/acl/util/create-acl-permission-detail';
import { connectState, InputObservable } from '@y42/angular/util';
import { Observable, tap } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'y42-upload-image-button',
  templateUrl: './upload-image-button.component.html',
  styleUrls: ['./upload-image-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadImageButtonComponent implements OnInit {
  @Input() active = false;

  @Input()
  @InputObservable()
  isCanvasEditable = createAclPermissionDetail({ allowed: false });
  private readonly isCanvasEditable$!: Observable<AclPermissionDetail>;

  @Output() readonly selectTool = new EventEmitter<string>();

  readonly state = connectState(this, {
    isCanvasEditable: this.isCanvasEditable$,
  });

  protected readonly imageFormControl = new FormControl<string>('', { nonNullable: true });

  ngOnInit() {
    this.imageFormControl.valueChanges
      .pipe(
        tap((image: string) => {
          this.selectTool.emit(image);
        }),
        untilDestroyed(this),
      )
      .subscribe();
  }
}
